module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEwIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjA4MjY4IDEuNTE4MDZMOC4yNjAxOCAwLjY5NTU1N0w0Ljk5OTM1IDMuOTU2MzlMMS43Mzg1MiAwLjY5NTU1N0wwLjkxNjAxNiAxLjUxODA2TDQuMTc2ODUgNC43Nzg4OUwwLjkxNjAxNiA4LjAzOTcyTDEuNzM4NTIgOC44NjIyMkw0Ljk5OTM1IDUuNjAxMzlMOC4yNjAxOCA4Ljg2MjIyTDkuMDgyNjggOC4wMzk3Mkw1LjgyMTg1IDQuNzc4ODlMOS4wODI2OCAxLjUxODA2WiIgZmlsbD0iI0RDNTc1NyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/img/clear.svg
// module id = 454
// module chunks = 462